<template>
  <component
      :class="[
      'fd-text mb-0 flex-shrink-0 font-weight-normal',
      { 'fd-text--fa': fa },
      { 'fd-text--font-size-unset': isTagPre },
      getTextAlignClasses(),
      getTextBehaviourClasses(),
      getTextColorClasses(),
      getTextDecorationClasses(),
      getTextFontFamily(),
      getTextSizeClasses(),
      getTextStyleClasses(),
      getTextTransformationClasses(),
      getTextWeightClasses(),
    ]"
      :is="getTag()"
  >
    <slot/>
  </component>
</template>

<script>
export default {
  name: "FdText",

  components: {},

  props: {
    alignCenter: [Boolean, String],
    alignJustify: [Boolean, String],
    alignLeft: [Boolean, String],
    alignRight: [Boolean, String],
    bold: [Boolean, String],
    colorAlert: [Boolean, String],
    colorDanger: [Boolean, String],
    colorGrey: [Boolean, String],
    colorLightGrey: [Boolean, String],
    colorLighterGrey: [Boolean, String],
    colorSuccess: [Boolean, String],
    colorTheme1: [Boolean, String],
    colorTheme2: [Boolean, String],
    colorTheme3: [Boolean, String],
    colorTheme4: [Boolean, String],
    colorWhite: [Boolean, String],
    fa: Boolean,
    fontFamilyMono: [Boolean, String],
    fontFamilyTheme: [Boolean, String],
    fontSizeBigger1: [Boolean, String],
    fontSizeBigger2: [Boolean, String],
    fontSizeBigger3: [Boolean, String],
    fontSizeBigger4: [Boolean, String],
    fontSizeBigger5: [Boolean, String],
    fontSizeBigger6: [Boolean, String],
    fontSizeBigger7: [Boolean, String],
    fontSizeBigger8: [Boolean, String],
    fontSizeBigger9: [Boolean, String],
    fontSizeBigger10: [Boolean, String],
    fontSizeNormal: [Boolean, String],
    fontSizeSmaller1: [Boolean, String],
    fontSizeSmaller2: [Boolean, String],
    fontSizeSmaller3: [Boolean, String],
    fontSizeSmaller4: [Boolean, String],
    fontSizeSmaller5: [Boolean, String],
    fontSizeSmaller6: [Boolean, String],
    italic: [Boolean, String],
    minContent: [Boolean, String],
    oneline: [Boolean, String],
    underlined: [Boolean, String],
    uppercase: [Boolean, String],
    tag: String,
  },

  data() {
    return {};
  },

  computed: {
    isTagPre() {
      return this.getTag() == "pre";
    },
  },

  watch: {},

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {
    getTag() {
      if (this.fa) return "div";

      return this.tag == "h1" ||
      this.tag == "h2" ||
      this.tag == "h3" ||
      this.tag == "h4" ||
      this.tag == "h5" ||
      this.tag == "h6" ||
      this.tag == "label" ||
      this.tag == "p" ||
      this.tag == "span"
          ? this.tag
          : "pre";
    },

    getTextAlignClasses() {
      let classes = [];

      if (this.alignCenter === true) classes.push("text-center");
      if (this.alignCenter === "sm") classes.push("text-sm-center");
      if (this.alignCenter === "md") classes.push("text-md-center");
      if (this.alignCenter === "lg") classes.push("text-lg-center");
      if (this.alignCenter === "xl") classes.push("text-xl-center");

      if (this.alignJustify === true) classes.push("text-justify");
      if (this.alignJustify === "sm") classes.push("text-sm-justify");
      if (this.alignJustify === "md") classes.push("text-md-justify");
      if (this.alignJustify === "lg") classes.push("text-lg-justify");
      if (this.alignJustify === "xl") classes.push("text-xl-justify");

      if (this.alignLeft === true) classes.push("text-left");
      if (this.alignLeft === "sm") classes.push("text-sm-left");
      if (this.alignLeft === "md") classes.push("text-md-left");
      if (this.alignLeft === "lg") classes.push("text-lg-left");
      if (this.alignLeft === "xl") classes.push("text-xl-left");

      if (this.alignRight === true) classes.push("text-right");
      if (this.alignRight === "sm") classes.push("text-sm-right");
      if (this.alignRight === "md") classes.push("text-md-right");
      if (this.alignRight === "lg") classes.push("text-lg-right");
      if (this.alignRight === "xl") classes.push("text-xl-right");

      return classes;
    },

    getTextBehaviourClasses() {
      let classes = [];

      if (this.minContent === true) classes.push("fd-text--min-content");
      if (this.minContent === "sm") classes.push("fd-text--sm-min-content");
      if (this.minContent === "md") classes.push("fd-text--md-min-content");
      if (this.minContent === "lg") classes.push("fd-text--lg-min-content");
      if (this.minContent === "xl") classes.push("fd-text--xl-min-content");

      if (this.oneline === true) classes.push("fd-text--oneline");
      if (this.oneline === "sm") classes.push("fd-text--sm-oneline");
      if (this.oneline === "md") classes.push("fd-text--md-oneline");
      if (this.oneline === "lg") classes.push("fd-text--lg-oneline");
      if (this.oneline === "xl") classes.push("fd-text--xl-oneline");

      return classes;
    },

    getTextColorClasses() {
      let classes = [];

      if (this.colorAlert === true) classes.push("fd-text--color-alert");
      if (this.colorAlert === "sm") classes.push("fd-text--color-sm-alert");
      if (this.colorAlert === "md") classes.push("fd-text--color-md-alert");
      if (this.colorAlert === "lg") classes.push("fd-text--color-lg-alert");
      if (this.colorAlert === "xl") classes.push("fd-text--color-xl-alert");

      if (this.colorDanger === true) classes.push("fd-text--color-danger");
      if (this.colorDanger === "sm") classes.push("fd-text--color-sm-danger");
      if (this.colorDanger === "md") classes.push("fd-text--color-md-danger");
      if (this.colorDanger === "lg") classes.push("fd-text--color-lg-danger");
      if (this.colorDanger === "xl") classes.push("fd-text--color-xl-danger");

      if (this.colorGrey === true) classes.push("fd-text--color-grey");
      if (this.colorGrey === "sm") classes.push("fd-text--color-sm-grey");
      if (this.colorGrey === "md") classes.push("fd-text--color-md-grey");
      if (this.colorGrey === "lg") classes.push("fd-text--color-lg-grey");
      if (this.colorGrey === "xl") classes.push("fd-text--color-xl-grey");

      if (this.colorLightGrey === true)
        classes.push("fd-text--color-light-grey");
      if (this.colorLightGrey === "sm")
        classes.push("fd-text--color-sm-light-grey");
      if (this.colorLightGrey === "md")
        classes.push("fd-text--color-md-light-grey");
      if (this.colorLightGrey === "lg")
        classes.push("fd-text--color-lg-light-grey");
      if (this.colorLightGrey === "xl")
        classes.push("fd-text--color-xl-light-grey");

      if (this.colorLighterGrey === true)
        classes.push("fd-text--color-lighter-grey");
      if (this.colorLighterGrey === "sm")
        classes.push("fd-text--color-sm-lighter-grey");
      if (this.colorLighterGrey === "md")
        classes.push("fd-text--color-md-lighter-grey");
      if (this.colorLighterGrey === "lg")
        classes.push("fd-text--color-lg-lighter-grey");
      if (this.colorLighterGrey === "xl")
        classes.push("fd-text--color-xl-lighter-grey");

      if (this.colorSuccess === true) classes.push("fd-text--color-success");
      if (this.colorSuccess === "sm") classes.push("fd-text--color-sm-success");
      if (this.colorSuccess === "md") classes.push("fd-text--color-md-success");
      if (this.colorSuccess === "lg") classes.push("fd-text--color-lg-success");
      if (this.colorSuccess === "xl") classes.push("fd-text--color-xl-success");

      if (this.colorTheme1 === true) classes.push("fd-text--color-theme-1");
      if (this.colorTheme1 === "sm") classes.push("fd-text--color-sm-theme-1");
      if (this.colorTheme1 === "md") classes.push("fd-text--color-md-theme-1");
      if (this.colorTheme1 === "lg") classes.push("fd-text--color-lg-theme-1");
      if (this.colorTheme1 === "xl") classes.push("fd-text--color-xl-theme-1");

      if (this.colorTheme2 === true) classes.push("fd-text--color-theme-2");
      if (this.colorTheme2 === "sm") classes.push("fd-text--color-sm-theme-2");
      if (this.colorTheme2 === "md") classes.push("fd-text--color-md-theme-2");
      if (this.colorTheme2 === "lg") classes.push("fd-text--color-lg-theme-2");
      if (this.colorTheme2 === "xl") classes.push("fd-text--color-xl-theme-2");

      if (this.colorTheme3 === true) classes.push("fd-text--color-theme-3");
      if (this.colorTheme3 === "sm") classes.push("fd-text--color-sm-theme-3");
      if (this.colorTheme3 === "md") classes.push("fd-text--color-md-theme-3");
      if (this.colorTheme3 === "lg") classes.push("fd-text--color-lg-theme-3");
      if (this.colorTheme3 === "xl") classes.push("fd-text--color-xl-theme-3");

      if (this.colorTheme4 === true) classes.push("fd-text--color-theme-4");
      if (this.colorTheme4 === "sm") classes.push("fd-text--color-sm-theme-4");
      if (this.colorTheme4 === "md") classes.push("fd-text--color-md-theme-4");
      if (this.colorTheme4 === "lg") classes.push("fd-text--color-lg-theme-4");
      if (this.colorTheme4 === "xl") classes.push("fd-text--color-xl-theme-4");

      if (this.colorWhite === true) classes.push("fd-text--color-white");
      if (this.colorWhite === "sm") classes.push("fd-text--color-sm-white");
      if (this.colorWhite === "md") classes.push("fd-text--color-md-white");
      if (this.colorWhite === "lg") classes.push("fd-text--color-lg-white");
      if (this.colorWhite === "xl") classes.push("fd-text--color-xl-white");

      return classes;
    },

    getTextDecorationClasses() {
      let classes = [];

      if (this.underlined === true) classes.push("fd-text--underlined");
      if (this.underlined === "sm") classes.push("fd-text--sm-underlined");
      if (this.underlined === "md") classes.push("fd-text--md-underlined");
      if (this.underlined === "lg") classes.push("fd-text--lg-underlined");
      if (this.underlined === "xl") classes.push("fd-text--xl-underlined");

      return classes;
    },

    getTextFontFamily() {
      let classes = [];

      if (this.fontFamilyMono === true)
        classes.push("fd-text--font-family-mono");
      if (this.fontFamilyMono === "sm")
        classes.push("fd-text--font-family-sm-mono");
      if (this.fontFamilyMono === "md")
        classes.push("fd-text--font-family-md-mono");
      if (this.fontFamilyMono === "lg")
        classes.push("fd-text--font-family-lg-mono");
      if (this.fontFamilyMono === "xl")
        classes.push("fd-text--font-family-lg-mono");

      if (this.fontFamilyTheme === true)
        classes.push("fd-text--font-family-theme");
      if (this.fontFamilyTheme === "sm")
        classes.push("fd-text--font-family-sm-theme");
      if (this.fontFamilyTheme === "md")
        classes.push("fd-text--font-family-md-theme");
      if (this.fontFamilyTheme === "lg")
        classes.push("fd-text--font-family-lg-theme");
      if (this.fontFamilyTheme === "xl")
        classes.push("fd-text--font-family-lg-theme");

      return classes;
    },

    getTextSizeClasses() {
      let classes = [];

      if (this.fontSizeBigger1 === true)
        classes.push("fd-text--font-size-bigger-1");
      if (this.fontSizeBigger1 === "sm")
        classes.push("fd-text--font-size-sm-bigger-1");
      if (this.fontSizeBigger1 === "md")
        classes.push("fd-text--font-size-md-bigger-1");
      if (this.fontSizeBigger1 === "lg")
        classes.push("fd-text--font-size-lg-bigger-1");
      if (this.fontSizeBigger1 === "xl")
        classes.push("fd-text--font-size-xl-bigger-1");

      if (this.fontSizeBigger2 === true)
        classes.push("fd-text--font-size-bigger-2");
      if (this.fontSizeBigger2 === "sm")
        classes.push("fd-text--font-size-sm-bigger-2");
      if (this.fontSizeBigger2 === "md")
        classes.push("fd-text--font-size-md-bigger-2");
      if (this.fontSizeBigger2 === "lg")
        classes.push("fd-text--font-size-lg-bigger-2");
      if (this.fontSizeBigger2 === "xl")
        classes.push("fd-text--font-size-xl-bigger-2");

      if (this.fontSizeBigger3 === true)
        classes.push("fd-text--font-size-bigger-3");
      if (this.fontSizeBigger3 === "sm")
        classes.push("fd-text--font-size-sm-bigger-3");
      if (this.fontSizeBigger3 === "md")
        classes.push("fd-text--font-size-md-bigger-3");
      if (this.fontSizeBigger3 === "lg")
        classes.push("fd-text--font-size-lg-bigger-3");
      if (this.fontSizeBigger3 === "xl")
        classes.push("fd-text--font-size-xl-bigger-3");

      if (this.fontSizeBigger4 === true)
        classes.push("fd-text--font-size-bigger-4");
      if (this.fontSizeBigger4 === "sm")
        classes.push("fd-text--font-size-sm-bigger-4");
      if (this.fontSizeBigger4 === "md")
        classes.push("fd-text--font-size-md-bigger-4");
      if (this.fontSizeBigger4 === "lg")
        classes.push("fd-text--font-size-lg-bigger-4");
      if (this.fontSizeBigger4 === "xl")
        classes.push("fd-text--font-size-xl-bigger-4");

      if (this.fontSizeBigger5 === true)
        classes.push("fd-text--font-size-bigger-5");
      if (this.fontSizeBigger5 === "sm")
        classes.push("fd-text--font-size-sm-bigger-5");
      if (this.fontSizeBigger5 === "md")
        classes.push("fd-text--font-size-md-bigger-5");
      if (this.fontSizeBigger5 === "lg")
        classes.push("fd-text--font-size-lg-bigger-5");
      if (this.fontSizeBigger5 === "xl")
        classes.push("fd-text--font-size-xl-bigger-5");

      if (this.fontSizeBigger6 === true)
        classes.push("fd-text--font-size-bigger-6");
      if (this.fontSizeBigger6 === "sm")
        classes.push("fd-text--font-size-sm-bigger-6");
      if (this.fontSizeBigger6 === "md")
        classes.push("fd-text--font-size-md-bigger-6");
      if (this.fontSizeBigger6 === "lg")
        classes.push("fd-text--font-size-lg-bigger-6");
      if (this.fontSizeBigger6 === "xl")
        classes.push("fd-text--font-size-xl-bigger-6");

      if (this.fontSizeBigger7 === true)
        classes.push("fd-text--font-size-bigger-7");
      if (this.fontSizeBigger7 === "sm")
        classes.push("fd-text--font-size-sm-bigger-7");
      if (this.fontSizeBigger7 === "md")
        classes.push("fd-text--font-size-md-bigger-7");
      if (this.fontSizeBigger7 === "lg")
        classes.push("fd-text--font-size-lg-bigger-7");
      if (this.fontSizeBigger7 === "xl")
        classes.push("fd-text--font-size-xl-bigger-7");

      if (this.fontSizeBigger8 === true)
        classes.push("fd-text--font-size-bigger-8");
      if (this.fontSizeBigger8 === "sm")
        classes.push("fd-text--font-size-sm-bigger-8");
      if (this.fontSizeBigger8 === "md")
        classes.push("fd-text--font-size-md-bigger-8");
      if (this.fontSizeBigger8 === "lg")
        classes.push("fd-text--font-size-lg-bigger-8");
      if (this.fontSizeBigger8 === "xl")
        classes.push("fd-text--font-size-xl-bigger-8");

      if (this.fontSizeBigger9 === true)
        classes.push("fd-text--font-size-bigger-9");
      if (this.fontSizeBigger9 === "sm")
        classes.push("fd-text--font-size-sm-bigger-9");
      if (this.fontSizeBigger9 === "md")
        classes.push("fd-text--font-size-md-bigger-9");
      if (this.fontSizeBigger9 === "lg")
        classes.push("fd-text--font-size-lg-bigger-9");
      if (this.fontSizeBigger9 === "xl")
        classes.push("fd-text--font-size-xl-bigger-9");

      if (this.fontSizeBigger10 === true)
        classes.push("fd-text--font-size-bigger-10");
      if (this.fontSizeBigger10 === "sm")
        classes.push("fd-text--font-size-sm-bigger-10");
      if (this.fontSizeBigger10 === "md")
        classes.push("fd-text--font-size-md-bigger-10");
      if (this.fontSizeBigger10 === "lg")
        classes.push("fd-text--font-size-lg-bigger-10");
      if (this.fontSizeBigger10 === "xl")
        classes.push("fd-text--font-size-xl-bigger-10");

      if (this.fontSizeNormal === true)
        classes.push("fd-text--font-size-normal");
      if (this.fontSizeNormal === "sm")
        classes.push("fd-text--font-size-sm-normal");
      if (this.fontSizeNormal === "md")
        classes.push("fd-text--font-size-md-normal");
      if (this.fontSizeNormal === "lg")
        classes.push("fd-text--font-size-lg-normal");
      if (this.fontSizeNormal === "xl")
        classes.push("fd-text--font-size-xl-normal");

      if (this.fontSizeSmaller1 === true)
        classes.push("fd-text--font-size-smaller-1");
      if (this.fontSizeSmaller1 === "sm")
        classes.push("fd-text--font-size-sm-smaller-1");
      if (this.fontSizeSmaller1 === "md")
        classes.push("fd-text--font-size-md-smaller-1");
      if (this.fontSizeSmaller1 === "lg")
        classes.push("fd-text--font-size-lg-smaller-1");
      if (this.fontSizeSmaller1 === "xl")
        classes.push("fd-text--font-size-xl-smaller-1");

      if (this.fontSizeSmaller2 === true)
        classes.push("fd-text--font-size-smaller-2");
      if (this.fontSizeSmaller2 === "sm")
        classes.push("fd-text--font-size-sm-smaller-2");
      if (this.fontSizeSmaller2 === "md")
        classes.push("fd-text--font-size-md-smaller-2");
      if (this.fontSizeSmaller2 === "lg")
        classes.push("fd-text--font-size-lg-smaller-2");
      if (this.fontSizeSmaller2 === "xl")
        classes.push("fd-text--font-size-xl-smaller-2");

      if (this.fontSizeSmaller3 === true)
        classes.push("fd-text--font-size-smaller-3");
      if (this.fontSizeSmaller3 === "sm")
        classes.push("fd-text--font-size-sm-smaller-3");
      if (this.fontSizeSmaller3 === "md")
        classes.push("fd-text--font-size-md-smaller-3");
      if (this.fontSizeSmaller3 === "lg")
        classes.push("fd-text--font-size-lg-smaller-3");
      if (this.fontSizeSmaller3 === "xl")
        classes.push("fd-text--font-size-xl-smaller-3");

      if (this.fontSizeSmaller4 === true)
        classes.push("fd-text--font-size-smaller-4");
      if (this.fontSizeSmaller4 === "sm")
        classes.push("fd-text--font-size-sm-smaller-4");
      if (this.fontSizeSmaller4 === "md")
        classes.push("fd-text--font-size-md-smaller-4");
      if (this.fontSizeSmaller4 === "lg")
        classes.push("fd-text--font-size-lg-smaller-4");
      if (this.fontSizeSmaller4 === "xl")
        classes.push("fd-text--font-size-xl-smaller-4");

      if (this.fontSizeSmaller5 === true)
        classes.push("fd-text--font-size-smaller-5");
      if (this.fontSizeSmaller5 === "sm")
        classes.push("fd-text--font-size-sm-smaller-5");
      if (this.fontSizeSmaller5 === "md")
        classes.push("fd-text--font-size-md-smaller-5");
      if (this.fontSizeSmaller5 === "lg")
        classes.push("fd-text--font-size-lg-smaller-5");
      if (this.fontSizeSmaller5 === "xl")
        classes.push("fd-text--font-size-xl-smaller-5");

      if (this.fontSizeSmaller6 === true)
        classes.push("fd-text--font-size-smaller-6");
      if (this.fontSizeSmaller6 === "sm")
        classes.push("fd-text--font-size-sm-smaller-6");
      if (this.fontSizeSmaller6 === "md")
        classes.push("fd-text--font-size-md-smaller-6");
      if (this.fontSizeSmaller6 === "lg")
        classes.push("fd-text--font-size-lg-smaller-6");
      if (this.fontSizeSmaller6 === "xl")
        classes.push("fd-text--font-size-xl-smaller-6");

      return classes;
    },

    getTextStyleClasses() {
      let classes = [];

      if (this.italic === true) classes.push("font-italic");
      if (this.italic === "sm") classes.push("font-sm-italic");
      if (this.italic === "md") classes.push("font-md-italic");
      if (this.italic === "lg") classes.push("font-lg-italic");
      if (this.italic === "xl") classes.push("font-xl-italic");

      return classes;
    },

    getTextTransformationClasses() {
      let classes = [];

      if (this.uppercase === true) classes.push("text-uppercase");
      if (this.uppercase === "sm") classes.push("text-sm-uppercase");
      if (this.uppercase === "md") classes.push("text-md-uppercase");
      if (this.uppercase === "lg") classes.push("text-lg-uppercase");
      if (this.uppercase === "xl") classes.push("text-xl-uppercase");

      return classes;
    },

    getTextWeightClasses() {
      let classes = [];

      if (this.bold === true) classes.push("font-weight-bold");
      if (this.bold === "sm") classes.push("font-weight-sm-bold");
      if (this.bold === "md") classes.push("font-weight-md-bold");
      if (this.bold === "lg") classes.push("font-weight-lg-bold");
      if (this.bold === "xl") classes.push("font-weight-xl-bold");

      return classes;
    },
  },
};
</script>

<style lang="scss">
@import "@/sass/flexdesign-overloads/text";

// Default breakpoint is extra small devices (portrait phones, less than 576px)
$screen-breakpoints: (
  // Small devices (landscape phones, 576px and up)
    "sm": 576px,
  // Medium devices (tablets, 768px and up)
    "md": 768px,
  // Large devices (desktops, 992px and up)
    "lg": 992px,
  // Extra large devices (large desktops, 1200px and up)
    "xl": 1200px
);

/* =========================================================================
 * TEXT
 * ========================================================================= */

/* TEXT BASIS
 * ------------------------------------------------------------------------- */

.fd-text {
  display: block;

  overflow: hidden;
  max-width: 100%;
  max-height: 100%;

  line-height: 1.5;
  white-space: pre-line;
  word-wrap: break-word;
  text-overflow: ellipsis;
}

/* SPECIFIC TEXTS
 * ------------------------------------------------------------------------- */

// For Font Awesome
.fd-text--fa {
  font-size: 0.75rem; // Mirror of the font size set on the body tag
}

// Extra small devices
.fd-text--oneline {
  white-space: nowrap !important;
}

.fd-text--min-content {
  width: min-content !important;
}

.fd-text--underlined {
  text-decoration: underline !important;
}

// Small devices
@media (min-width: map-get($screen-breakpoints, "sm")) {
  .fd-text--sm-oneline {
    white-space: nowrap !important;
  }

  .fd-text--sm-min-content {
    width: min-content !important;
  }

  .fd-text--sm-underlined {
    text-decoration: underline !important;
  }
}

// Medium devices
@media (min-width: map-get($screen-breakpoints, "md")) {
  .fd-text--md-oneline {
    white-space: nowrap !important;
  }

  .fd-text--md-min-content {
    width: min-content !important;
  }

  .fd-text--md-underlined {
    text-decoration: underline !important;
  }
}

// Large devices
@media (min-width: map-get($screen-breakpoints, "lg")) {
  .fd-text--lg-oneline {
    white-space: nowrap !important;
  }

  .fd-text--lg-min-content {
    width: min-content !important;
  }

  .fd-text--lg-underlined {
    text-decoration: underline !important;
  }
}

// Extra large devices
@media (min-width: map-get($screen-breakpoints, "xl")) {
  .fd-text--xl-oneline {
    white-space: nowrap !important;
  }

  .fd-text--xl-min-content {
    width: min-content !important;
  }

  .fd-text--xl-underlined {
    text-decoration: underline !important;
  }
}

@mixin set-class($name, $property, $value) {
  &#{$name} {
    #{$property}: $value !important;
  }
}

@mixin set-color-classes() {
  $text-color-basis-class-name: "fd-text--color";
  $property: "color";
  $colors: (
      "alert": $fd-color-alert,
      "danger": $fd-color-danger,
      "grey": $fd-color-grey-6,
      "light-grey": $fd-color-grey-5,
      "lighter-grey": $fd-color-grey-3,
      "success": $fd-color-success,
      "theme-1": $fd-color-theme-1,
      "theme-2": $fd-color-theme-2,
      "theme-3": $fd-color-theme-3,
      "theme-4": $fd-color-theme-4,
      "white": $fd-color-white,
  );

  .#{$text-color-basis-class-name}- {
    @include set-class("unset", $property, unset);
    @each $key, $value in $colors {
      @include set-class($key, $property, $value);
    }
  }
  @each $i-key, $i-value in $screen-breakpoints {
    @media (min-width: $i-value) {
      .#{$text-color-basis-class-name}-#{$i-key}- {
        @include set-class("unset", $property, unset);
        @each $j-key, $j-value in $colors {
          @include set-class($j-key, $property, $j-value);
        }
      }
    }
  }
}

@mixin set-font-family-classes() {
  $text-font-family-basis-class-name: "fd-text--font-family";
  $property: "font-family";
  $font-families: (
      "mono": $fd-font-family-mono,
      "theme": $fd-font-family-theme,
  );

  .#{$text-font-family-basis-class-name}- {
    @include set-class("unset", $property, unset);
    @each $key, $value in $font-families {
      @include set-class($key, $property, $value);
    }
  }
  @each $i-key, $i-value in $screen-breakpoints {
    @media (min-width: $i-value) {
      .#{$text-font-family-basis-class-name}-#{$i-key}- {
        @include set-class("unset", $property, unset);
        @each $j-key, $j-value in $font-families {
          @include set-class($j-key, $property, $j-value);
        }
      }
    }
  }
}

@mixin set-font-size-classes() {
  $font-size-basis-class-name: "fd-text--font-size";
  $property: "font-size";
  $font-sizes: (
      "bigger-1": $fd-font-size-bigger-1,
      "bigger-2": $fd-font-size-bigger-2,
      "bigger-3": $fd-font-size-bigger-3,
      "bigger-4": $fd-font-size-bigger-4,
      "bigger-5": $fd-font-size-bigger-5,
      "bigger-6": $fd-font-size-bigger-6,
      "bigger-7": $fd-font-size-bigger-7,
      "bigger-8": $fd-font-size-bigger-8,
      "bigger-9": $fd-font-size-bigger-9,
      "bigger-10": $fd-font-size-bigger-10,
      "normal": $fd-font-size-normal,
      "smaller-1": $fd-font-size-smaller-1,
      "smaller-2": $fd-font-size-smaller-2,
      "smaller-3": $fd-font-size-smaller-3,
      "smaller-4": $fd-font-size-smaller-4,
      "smaller-5": $fd-font-size-smaller-5,
      "smaller-6": $fd-font-size-smaller-6,
  );

  .#{$font-size-basis-class-name}- {
    @include set-class("unset", $property, unset);
    @each $key, $value in $font-sizes {
      @include set-class($key, $property, $value);
    }
  }
  @each $i-key, $i-value in $screen-breakpoints {
    @media (min-width: $i-value) {
      .#{$font-size-basis-class-name}-#{$i-key}- {
        @include set-class("unset", $property, unset);
        @each $j-key, $j-value in $font-sizes {
          @include set-class($j-key, $property, $j-value);
        }
      }
    }
  }
}

@include set-color-classes();
@include set-font-family-classes();
@include set-font-size-classes();
</style>
